import {useState} from 'react'

import PropTypes from 'prop-types'

import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'
import FormBodyType from '@adv-mt/mt-form-body-type'

export const BodyTypesFilter = ({options, onChange, value}) => {
  const [selectedBodyTypeOption, setSelectedBodyTypeOption] = useState(value || [])

  const _handleOnChange = (e, item) => {
    const {value: newBodyTypeId} = item
    setSelectedBodyTypeOption(newBodyTypeId)
    onChange(newBodyTypeId)
  }

  return (
    <FormBodyType
      value={selectedBodyTypeOption}
      type={filterBasicTypes.IMAGE_MULTI_SELECTION_GRID_COLUMN_WITH_BORDER}
      onChange={_handleOnChange}
      options={options}
      wrapper={filterWrapperBasicTypes.NONE}
    />
  )
}

BodyTypesFilter.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object
}
